export default class Object_ {
    returnModel() {
        return {
            id: null,
            parentObject: null,
            application: null,
            objectType: null,
            uniqueCode: null,
            description: null,
            addDate: null,
            obsoleteDate: null,
            child: [ ]
        }
    }
}